import type { ReactNode } from 'react';

type PageHeaderProps = {
  start: ReactNode;
  end?: ReactNode;
};

const PageHeader = ({ start, end }: PageHeaderProps) => (
  <div className={'flex justify-between items-center px-7 py-6'}>
    <div className={'flex items-center'}>{start}</div>
    <div className={'flex items-center'}>{end}</div>
  </div>
);

export { PageHeader };
export type { PageHeaderProps };
